export const EventEmitter = payload => ({ $event: payload });
